import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import * as styles from './RowItem.module.scss';

export type RowItemProps = {
  label: string;
  value: React.ReactNode;
  link?: string;
  dataTest?: string;
};

export const RowItem: React.FC<RowItemProps> = ({
  label,
  value,
  link,
  dataTest,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.labelField}>{label}</div>
      <div className={styles.valueField}>{value}</div>
      <div className={styles.linkField}>
        {link && (
          <Link to={link} data-test={dataTest} className={styles.link}>
            <FaExternalLinkAlt />
            {t('ui.action.change')}
          </Link>
        )}
      </div>
    </div>
  );
};
